// @flow
import React, {PureComponent} from 'react';
import {StyleSheet} from 'react-native';
import {
  ActivityIndicator,
  ErrorMessageRetryBackdrop,
} from 'trpc-react-native-ui';
import {WebView} from 'react-native-webview';
import Uri from 'urijs';
import HandleErrorService from '../../lib/handleError';
import config from '../../config';

class HelpCenter extends PureComponent<void, State> {
  styles = getStyles();

  state = {
    isFetching: false,
    isFailure: true,
    loggedUrl: config.GENESYS_SUPPORT_URL,
    errorMessage: null,
    isWebviewChannelAdded: false,
  };

  componentDidMount() {
    this.setState({loggedUrl: config.GENESYS_SUPPORT_URL, isFetching: false, isFailure: false});
  }

  _onRefresh = () => {
    this.setState({loggedUrl: config.GENESYS_SUPPORT_URL, isFetching: false, isFailure: false});
  };

  _onError = e => {
    const errorMessage = HandleErrorService.getErrorMessage(e);
    this.setState({
      loggedUrl: null,
      isFetching: false,
      isFailure: true,
      errorMessage,
    });
  };

  addWebviewChannelOnLoad = ({nativeEvent}: any) => {
    if (this.state.isWebviewChannelAdded) return;
    const uri = new Uri(nativeEvent.url);
    if (!uri.search(true).channel) {
      this.setState({
        isWebviewChannelAdded: true,
        loggedUrl: uri.addSearch('channel', 'webview').toString(),
      });
    }
  };

  renderActivityIndicator = () => (
    <ActivityIndicator color="grey" style={this.styles.loader} />
  );

  render() {
    if (this.state.isFailure) {
      return (
        <ErrorMessageRetryBackdrop
          onRetry={this._onRefresh}
          errorMessage={this.state.errorMessage}
        />
      );
    }

    if (this.state.isFetching) {
      return this.renderActivityIndicator();
    }

    return (
      <WebView
        originWhitelist={['https://']}
        source={{uri: this.state.loggedUrl}}
        startInLoadingState
        onLoad={this.addWebviewChannelOnLoad}
        renderLoading={this.renderActivityIndicator}
        onError={this._onError}
      />
    );
  }
}

type State = {
  loggedUrl: ?string,
  isFetching: boolean,
  isFailure: boolean,
  errorMessage: ?string,
  isWebviewChannelAdded: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    loader: {
      position: 'absolute',
      height: '100%',
      width: '100%',
    },
  });

export default HelpCenter;
